<div class="backdrop"></div>
<div class="box">
    <div class="spinner-border text-danger"
        role="status"
        style="text-align: center; margin-bottom: 10px; width: 3rem; height: 3rem;">
            <!-- <span class="sr-only">Loading...</span> -->
    </div>
    <p>{{ message }}</p>
</div>